export default (o, c, d) => {
  c.prototype.isCurrentYear = function () {
    const today = window.dayjs.today()
    return this.year() === today.year()
  }
}
